import { render, staticRenderFns } from "./ForgotPasswordResetView.vue?vue&type=template&id=ad0908a0"
import script from "./ForgotPasswordResetView.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordResetView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports